import { makeProxyRequest } from '../utils/request';
import { rpc } from './helper';

export const uploadCustomFormFileUpload = payload =>
  makeProxyRequest('post', rpc(`/upload`), true, payload);

export const addOnboardingData = (inviteId, payload) =>
  makeProxyRequest(
    'post',
    rpc(`/invite.add_extra_data?invite_id=${inviteId}`),
    true,
    payload
  );

export const setOnboarded = () =>
  makeProxyRequest('post', rpc(`/user.onboarded`), true, {});
